<template>
  <span class="beta-badge">BETA</span>
</template>

<style scoped>
  .beta-badge {
    @apply inline-flex items-center justify-center rounded-full bg-orange-100 px-2.5 py-1 text-xs font-semibold text-orange-700;
    font-size: 0.7rem;
    line-height: 1;
  }
</style>
